import './StandardMultiLineTextEntry.css';
import React from 'react';

const errorBorderStyle = {
  border: '3px solid red',
  borderRadius: '6px',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  fontFamily: 'Verdana, Geneva, sans-serif',
  color: '#666666',
};

const normalBorderStyle = {
  border: 'none',
  verticalAlign: 'middle',
  marginTop: '4px',
  fontSize: '18px',
  fontFamily: 'Verdana, Geneva, sans-serif',
  color: '#666666',
};

export function StandardMultiLineTextEntry({
  title,
  data,
  setData,
  maxCharacters = 500, // Default maxCharacters
  setCharacterCount = () => {}, // No-op function to avoid errors
  characterCount = 0,
  onError = false,
  onErrorSet = () => {},
  errorText = '',
  errorTextSet = () => {},
  displayCounter = false,
  nullAllowed = true,
}) {
  const handleValueChange = (event) => {
    const value = event.target.value;
    const charCount = value.length;

    // Update character count
    setCharacterCount(charCount);

    if (charCount > maxCharacters) {
      onErrorSet(true);
      errorTextSet(`${title} must be ${maxCharacters} characters or less`);
    } else if (!value && !nullAllowed) {
      onErrorSet(true);
      errorTextSet(`${title} cannot be blank`);
    } else {
      onErrorSet(false);
      errorTextSet('');
    }

    // Update field value
    setData(value);
  };

  return (
    <div className="mlteFormRow">
      <div className="mlteTitleDiv">
        <label className="mlteTitleLabel">{title}</label>
      </div>
      <div className="mlteInputDiv">
        <textarea
          style={onError ? errorBorderStyle : normalBorderStyle}
          className="mlteTextArea"
          value={data}
          onChange={handleValueChange}
        />
        {displayCounter && (
          <label className="mlteCounterLabel">
            {characterCount}/{maxCharacters}
          </label>
        )}
        <label className="mlteErrorLabel">{errorText}</label>
      </div>
    </div>
  );
}
